import {qs, qsArray, trackEvent, getQueryStringVariable} from './utilities/index';
import MPI from "./mpi";
import Overlay from "./overlay";

const VALUES = {
  weightAmount: null,
  weightIds: null,
  color: null,
  scores: {
    v1: 0,
    v1x: 0,
    avx: 0,
    v1xld: 0,
    'tour-soft': 0,
    velocity: 0,
    trufeel: 0
  }
};

const EASE_IN_DURATION = 0.5;
const EASE_IN_STAGGER = "-=0.35";
const EASE_OUT_DURATION = 0.25;

// const EASE_IN_DURATION = 0.75;
// const EASE_IN_STAGGER = "-=0.5";
// const EASE_OUT_DURATION = 0.25;

let Results = function (params) {
  let results = this;
  // parent for entire section
  let resultsEl = params.el;
  let resultsContentEl = qs('.results-content', resultsEl);
  let pageMainEl = document.getElementById('main');

  // use these to switch between recommended and alternative
  // parent for all primary result elements
  let primaryParentEl = qs('.primary-content', resultsEl);
  // parent for all secondary result elements
  let secondaryParentEl = qs('.secondary-content', resultsEl);

  // is the results section active
  let isActive = false;
  let isExpanded = false;
  let timeline = null;

  // string id for each result
  let primaryResultId = null;
  let secondaryResultId = null;
  let primaryResultIndex = 0;
  let secondaryResultIndex = 1;
  let primaryResultSuccess = false;
  let secondaryResultSuccess = false;

  // the result element
  let primaryEl = null;
  let secondaryEl = null;

  // color for each result
  let primaryColor = null;
  let secondaryColor = null;

  let compareOverlay = document.getElementById('compare-overlay');
  let compareBackBtn = qs('.back-btn', compareOverlay);

  let alternativeButtons = qsArray('.alternative-btn');
  let primaryButtons = qsArray('.primary-btn');
  let compareButtons = qsArray('.compare-btn');
  let restartButtons = qsArray('.restart-btn');
  let backButtons = qsArray('.results-back-btn');
  let sendResultsButtons = qsArray('.send-results-btn', resultsEl);
  let buyButtons = qsArray('.buy-link', resultsEl);
  let virtualButtons = qsArray('.virtual-results-btn', resultsEl);

  let mpi = new MPI();

  alternativeButtons.forEach(function (el) {
    el.addEventListener('click', hidePrimary);
  });

  primaryButtons.forEach(function (el) {
    el.addEventListener('click', hideAlternative);
  });

  compareButtons.forEach(function(el){
    el.addEventListener('click', showCompare);
  });

  restartButtons.forEach(function(el){
    el.addEventListener('click', restart);
  });

  backButtons.forEach(function (el) {
    el.addEventListener('click', goBack);
  });

  /*
  compareBackBtn.addEventListener('click', function () {
    hideCompare();
  });
  */

      /**
   * SEND RESULT TOGGLE
   * Display the Send Result Button and Dialogue if the SendResult variable is passed in the query string
   */
    let sendResult = false;
    try {
      if(getQueryStringVariable('sendResult') === "true")
      {
        sendResult = true;
      }
    } catch (e) {
      console.log('Error getting sendResult query string variables');
    }

    if(sendResult)
    {
      sendResultsButtons.forEach(function(el){
        el.style.display = "block";
        el.addEventListener('click', sendResults);
      });
    }
    else{
      sendResultsButtons.forEach(function(el){
        el.style.display = "none";
      });
    }

  /**
   * PARTNER TOGGLE
   * Hide the buy buttons if the partner variable is passed in the query string
   */
  let partner = false;
  let hasSweeps = false;
  try {
    if ( getQueryStringVariable('partner') === "true" ) {
      partner = true;
    }
  } catch (e) {
    console.log('Error getting partner query string variables');
  }

  if ( partner ) {
    buyButtons.forEach(function(el){
      el.style.display = 'none';
    });

    //hide Virtual Consultations link on partner sites?
    var resultFooters = document.querySelectorAll('.results-footer');
    resultFooters.forEach(function (el) {
      el.style.display = 'none';
    });

    var fittingLinks = document.querySelectorAll('.schedule-fitting-link');
    fittingLinks.forEach(function (el) {
      el.style.display = 'none';
    });

    var sweepsPromos = document.querySelectorAll('.results-sweeps-promo');
    
    sweepsPromos.forEach(function (el) {
      var sweepsLink = el.querySelector('.promo-sweeps-link');
      var partnerHref = 'data-partner-href';
      if (sweepsLink.getAttribute(partnerHref) != null && sweepsLink.getAttribute(partnerHref).length > 0) {
        sweepsLink.setAttribute('href', sweepsLink.getAttribute(partnerHref));
      } else {
        el.style.display = 'none';
      }
    });

  } else {
    buyButtons.forEach(function(el){
      el.addEventListener('click', onBuyClick);
    });
  }


  

  /**
   * TERMS TOGGLE
   * AutoCheck Interest Optin if Terms is passed in query string
   */
  let termsCheck = false;
  try {
    if ( getQueryStringVariable('termsCheck') === "true" ) {
      termsCheck = true;
    }
  } catch (e) {
    console.log('Error getting termsCheck query string variables');
  }
  let terms = document.getElementById('terms');
  terms.checked = termsCheck;


  virtualButtons.forEach(function(el){
    el.addEventListener('click', onVirtualClick);
  });

  function onBuyClick() {
    trackEvent('navigation', 'Results', 'Product Details');
  }

  function onVirtualClick() {
    trackEvent('navigation', 'Results', 'Schedule a Virtual Consultation');
  }

  function showAlternative() {
    clearTimeline();
    let animElArray = [];
    animElArray.push(qs('.content-header', secondaryParentEl));
    animElArray = animElArray.concat(qsArray('.col', secondaryEl));
    TweenLite.set(animElArray, { opacity: 0 });
    secondaryParentEl.classList.add('is-active');
    secondaryParentEl.classList.add('is-disabled');
    timeline = new TimelineLite({
      onComplete: function () {
        secondaryParentEl.classList.remove('is-disabled');
      }
    });
    animElArray.forEach(function (el, i) {
      if (i === 0) {
        timeline.to(el, EASE_IN_DURATION, { opacity: 1 });
      } else {
        timeline.to(el, EASE_IN_DURATION, { opacity: 1 }, EASE_IN_STAGGER);
      }
    });
    trackEvent('navigation', 'Results', 'See Alternative Results');
  }

  function showPrimary() {
    clearTimeline();
    let animElArray = [];
    animElArray.push(qs('.content-header', primaryParentEl));
    animElArray = animElArray.concat(qsArray('.col', primaryEl));
    TweenLite.set(animElArray, { opacity: 0 });
    primaryParentEl.classList.add('is-active');
    primaryParentEl.classList.add('is-disabled');
    timeline = new TimelineLite({
      onComplete: function () {
        primaryParentEl.classList.remove('is-disabled');
      }
    });
    animElArray.forEach(function (el, i) {
      if (i === 0) {
        timeline.to(el, EASE_IN_DURATION, { opacity: 1 });
      } else {
        timeline.to(el, EASE_IN_DURATION, { opacity: 1 }, EASE_IN_STAGGER);
      }
    });
    trackEvent('navigation', 'Results', 'See Primary Results');
  }

  function hidePrimary() {
    console.log('hidePrimary');
    hideCompare();
    clearTimeline();
    primaryParentEl.classList.add('is-disabled');
    timeline = new TimelineLite({
      onComplete: function () {
        primaryParentEl.classList.remove('is-active');
        primaryParentEl.classList.remove('is-disabled');
        TweenLite.set(primaryParentEl, { opacity: 1 });
        showAlternative()
      }
    });
    timeline.to(primaryParentEl, EASE_OUT_DURATION, { opacity: 0 });
    closeAccordion();
  }

  function hideAlternative() {
    console.log('hideAlt');
    hideCompare();
    clearTimeline();
    secondaryParentEl.classList.add('is-disabled');
    timeline = new TimelineLite({
      onComplete: function () {
        secondaryParentEl.classList.remove('is-active');
        secondaryParentEl.classList.remove('is-disabled');
        TweenLite.set(secondaryParentEl, { opacity: 1 });
        showPrimary();
      }
    });
    timeline.to(secondaryParentEl, EASE_OUT_DURATION, { opacity: 0 });
    closeAccordion();
  }

  function closeAccordion() {
    isExpanded = false;
    let accordionWrapper = qs('.results-accordion-wrapper.is-active', resultsEl);
    if (accordionWrapper) {
      let accordion = qs('.results-accordion-wrapper.is-active .results-accordion', resultsEl);
      accordion.style.height = 0;
      accordionWrapper.classList.remove('is-active');
    }
    pageMainEl.classList.remove('results-expanded');
    window.resizeFrame();
  }

  function showCompare() {
    closeAccordion();
    pageMainEl.classList.add('results-compare');
    window.resizeFrame();
    resultsEl.classList.add('is-disabled');
    TweenLite.set(compareOverlay, { opacity: 0 });
    TweenLite.to(resultsContentEl, EASE_OUT_DURATION, { opacity: 0, onComplete: function () {
        compareOverlay.classList.add('is-active');
        TweenLite.to(compareOverlay, EASE_IN_DURATION, { opacity: 1 });
      }});
    trackEvent('navigation', 'Compare', 'Show Compare Overlay');
  }

  function hideCompare() {
    compareOverlay.classList.add('is-disabled');
    pageMainEl.classList.remove('results-compare');
    window.resizeFrame();
    TweenLite.to(compareOverlay, EASE_OUT_DURATION, {
      opacity: 0, onComplete: function () {
        compareOverlay.classList.remove('is-active');
        compareOverlay.classList.remove('is-disabled');
        TweenLite.to(resultsContentEl, EASE_IN_DURATION, { opacity: 1, onComplete: function () {
            resultsEl.classList.remove('is-disabled');
          }});
      }});

    trackEvent('navigation', 'Compare', 'Hide Compare Overlay');
  }

  function setCompare() {
    // console.log(primaryEl, secondaryEl);
    clearCompare();

    let ballId = primaryEl.getAttribute('data-result');
    let imgStyle = qs('.product-image.is-active .img', primaryEl).getAttribute('style');
    let compareEl = qs('[data-ball="' + ballId + '"]', compareOverlay);
    let productImage = qs('.product-image', compareEl);
    productImage.setAttribute('style', imgStyle);
    compareEl.classList.add('is-optimal');
    qs('.mpi-value', compareEl).innerText = mpi.getPrimaryValue();

    ballId = secondaryEl.getAttribute('data-result');
    imgStyle = qs('.product-image.is-active .img', secondaryEl).getAttribute('style');
    compareEl = qs('[data-ball="' + ballId + '"]', compareOverlay);
    productImage = qs('.product-image', compareEl);
    productImage.setAttribute('style', imgStyle);
    compareEl.classList.add('is-alternative');
    qs('.mpi-value', compareEl).innerText = mpi.getSecondaryValue();

    // console.log(compareEl);
    // console.log(productImage);
    // console.log(ballId);
    // console.log(imgSrc);
  }

  function clearCompare () {
    let comparePrimaryEl = qs('.is-optimal', compareOverlay);
    let compareSecondaryEl = qs('.is-alternative', compareOverlay);
    if (comparePrimaryEl) {
      comparePrimaryEl.classList.remove('is-optimal');
    }
    if (compareSecondaryEl) {
      compareSecondaryEl.classList.remove('is-alternative');
    }
  }

  function sendResults () {
    let overlay = new Overlay();
    overlay.openSendResults('sign-in', primaryResultId, primaryColor, secondaryResultId, secondaryColor);
    trackEvent('navigation', 'Send Results', 'Open');
  }

  function restart() {
    hideCompare();
    params.restart();
    trackEvent('navigation', 'Home');
  }

  function goBack() {
    hideCompare();
    hidePrimary();
    hideAlternative();
    hideResults(function () {

    });
    trackEvent('navigation', 'Previous');
    params.goBack();
  }

  function hideResults(cb) {
    clearTimeline();
    isActive = false;
    resultsEl.classList.add('is-disabled');
    timeline = new TimelineLite({
      onComplete: function () {
        pageMainEl.classList.remove('results-visible');
        pageMainEl.classList.remove('results-expanded');
        resultsEl.classList.remove('is-active');
        resultsEl.classList.remove('is-disabled');
        clearResults();
        window.resizeFrame();
        if (cb) {
          cb();
        }
      }
    });
    timeline.to(resultsEl, EASE_OUT_DURATION, { opacity: 0 });
  }

  // Results public methods
  this.show = function(history) {
    console.log('Show results based on history', history);

    let resultObj = calcResults(history);
    let sortedResults = resultObj.sortedResults;
    let totals = resultObj.totals;
    console.log('resultObj', resultObj);

    primaryResultId = sortedResults[primaryResultIndex];
    secondaryResultId = sortedResults[secondaryResultIndex];

    primaryColor = sortedResults.color;
    secondaryColor = sortedResults.color;

    primaryEl = document.getElementById('primary-result-' + primaryResultId);
    primaryResultSuccess = setActive(primaryEl, primaryColor);
    if (!primaryResultSuccess) {
      primaryResultIndex += 1;
      secondaryResultIndex += 1;
      primaryResultId = sortedResults[primaryResultIndex];
      secondaryResultId = sortedResults[secondaryResultIndex];
      console.log('Primary result not available, shift primary result to ', primaryResultId);
      console.log('Shift secondary result to ', secondaryResultId);
      primaryEl = document.getElementById('primary-result-' + primaryResultId);
      primaryResultSuccess = setActive(primaryEl, primaryColor);
      if (!primaryResultSuccess) {
        console.warn('Primary result still not available, you should not get this');
      }
    }

    secondaryEl = document.getElementById('secondary-result-' + secondaryResultId);
    secondaryResultSuccess = setActive(secondaryEl, secondaryColor);
    if (!secondaryResultSuccess) {
      secondaryResultIndex += 1;
      secondaryResultId = sortedResults[secondaryResultIndex];
      console.log('Secondary result not available, shift result index to', secondaryResultId);
      secondaryEl = document.getElementById('secondary-result-' + secondaryResultId);
      secondaryResultSuccess = setActive(secondaryEl, secondaryColor);
      if (!secondaryResultSuccess) {
        console.warn('Secondary result still not available, you should not get this');
      }
    }

    trackEvent('Recommendation', 'Primary', primaryResultId, primaryColor);
    trackEvent('Recommendation', 'Alternative', secondaryResultId, secondaryColor);

    // set MPI
    mpi.calcPrimaryValue(primaryResultId, totals.scores[primaryResultId]);
    mpi.calcSecondaryValue(secondaryResultId, totals.scores[secondaryResultId]);
    qs('.mpi-value', primaryEl).innerText = mpi.getPrimaryValue();
    qs('.mpi-value', secondaryEl).innerText = mpi.getSecondaryValue();

    setCompare();

    // default to showing the primary result first
    primaryParentEl.classList.add('is-active');
    primaryParentEl.classList.add('is-visible');

    isActive = true;
    pageMainEl.classList.add('results-visible');
    window.resizeFrame();

    clearTimeline();
    let animElArray = [resultsEl];
    animElArray.push(qs('.content-header', primaryParentEl));
    animElArray = animElArray.concat(qsArray('.col', primaryEl));
    TweenLite.set(animElArray, { opacity: 0 });
    resultsEl.classList.add('is-active');
    timeline = new TimelineLite({
      onComplete: function() {
        // temp debug for compare overlay
        // setTimeout(function () {
        //   showCompare();
        // }, 250);
      }});
    animElArray.forEach(function (el, i) {
      if (i === 0) {
        timeline.to(el, EASE_IN_DURATION, { opacity: 1 });
      } else {
        timeline.to(el, EASE_IN_DURATION, { opacity: 1 }, EASE_IN_STAGGER);
      }
    });
  }

  this.hide = function(cb) {
    hideResults(cb);
  }

  this.getIsActive = function () {
    return isActive;
  }

  this.getIsExpanded = function () {
    return isExpanded;
  }

  // private methods
  function setActive (resultEl, color) {
    // title
    let titleEl = qs('.titles [data-color="' + color + '"]', resultEl);
    titleEl = titleEl === null ? qs('.titles [data-color="white"]', resultEl) : titleEl;
    if (titleEl) {
      titleEl.classList.add('is-active');
    } else {
      // Potentially return false here to shift the sorted results down
      console.warn('No title available for result', resultEl);
      return false;
    }
    // description
    let descEl = qs('.descriptions [data-color="' + color + '"]', resultEl);
    descEl = descEl === null ? qs('.descriptions [data-color="white"]', resultEl) : descEl;
    if (descEl) {
      descEl.classList.add('is-active');
    } else {
      // Potentially return false here to shift the sorted results down
      console.warn('No description available for result', resultEl);
      return false;
    }
    // product image
    let productEl = qs('.product-images [data-color="' + color + '"]', resultEl);
    productEl = productEl === null ? qs('.product-images [data-color="white"]', resultEl) : productEl;
    if (productEl) {
      productEl.classList.add('is-active');
    } else {
      // Potentially return false here to shift the sorted results down
      console.warn('No image available for result', resultEl);
      return false;
    }
    // buy button
    let buyEl = qs('.buy-links [data-color="' + color + '"]', resultEl);
    buyEl = buyEl === null ? qs('.buy-links [data-color="white"]', resultEl) : buyEl;
    if (buyEl) {
      buyEl.classList.add('is-active');
    }
    resultEl.classList.add('is-active');
    return true;
  }

  function calcResults (history) {
    // console.log('history', history);
    let totals = JSON.parse(JSON.stringify(VALUES));

    let fields;

    history.forEach(function(question){
      let values = question.values;
      console.log("Q=" + JSON.stringify(question));
      if (values.weightIds) {
        if (totals.weightIds) {
          console.warn('totals.weightIds already set', totals.weightIds);
        }
        totals.weightIds = values.weightIds;
      }

      if (values.weightAmount) {
        if (totals.weightAmount) {
          console.warn('totals.weightAmount already set', totals.weightAmount);
        }
        totals.weightAmount = parseFloat(values.weightAmount);
      }

      if (values.color) {
        if (totals.color) {
          console.warn('totals.color already set', totals.color);
        }
        totals.color = values.color;
      }

    });

    history.forEach(function(question) {
      let values = question.values;
      let scores = values.scores;
      let multiplier = 1;

      if (totals.weightIds && totals.weightIds.indexOf(question.id) !== -1) {
        multiplier = totals.weightAmount;
      }

      for (let prop in scores) {
        totals.scores[prop] += scores[prop] * multiplier;
      }

    });

    if ( totals.color === "" || totals.color === null ) {
      console.warn('totals.color was never set, defaulting to white');
      totals.color = "white";
    }

    mpi.calcPossibleMax(history, totals.weightIds, totals.weightAmount);
    // console.log('scores', totals.scores);
    // console.table(totals);

    let sortedResults = Object.keys(totals.scores).sort(function(a,b){return totals.scores[b]-totals.scores[a]});
    sortedResults.color = totals.color;

    // start Bad Combos check
    if (sortedResults[0] === "v1x" && sortedResults[1] === "avx") {
      // remove avx and move v1 into its place
      console.log('sortedResults', sortedResults);
      console.log('Bad Combo v1x and avx, remove avx and move v1 into its place');
      sortedResults.splice(sortedResults.indexOf('v1'), 1);
      sortedResults.splice(1, 1, 'v1');
    }
    if (sortedResults[0] === "avx" && sortedResults[1] === "v1x") {
      // remove v1x and move v1 into its place
      console.log('sortedResults', sortedResults);
      console.log('Bad Combo avx and v1x, remove v1x and move v1 into its place');
      sortedResults.splice(sortedResults.indexOf('v1'), 1);
      sortedResults.splice(1, 1, 'v1');
    }
    // end Bad Combos check

    // console.log('sortedResults', sortedResults);

    return {
      totals: totals,
      sortedResults: sortedResults
    };
  }

  function clearResults () {
    let isActiveArray = qsArray('.is-active', resultsEl);
    let isVisibleArray = qsArray('.is-visible', resultsEl);
    let isDisabledArray = qsArray('.is-disabled', resultsEl);

    isActiveArray.forEach(function (el) {
      el.classList.remove('is-active');
    });

    isVisibleArray.forEach(function (el) {
      el.classList.remove('is-visible');
    });

    isDisabledArray.forEach(function (el) {
      el.classList.remove('is-disabled');
    });
  }

  function clearTimeline() {
    if (timeline) {
      timeline.kill();
      timeline = null;
    }
  }

  var Accordion = function () {

    var
      toggleItems,
      items;

    var _init = function () {
      toggleItems = document.querySelectorAll('.btn-results-accordion');
      toggleItems = Array.prototype.slice.call(toggleItems);
      items = document.querySelectorAll('.results-accordion');
      items = Array.prototype.slice.call(items);

      _addEventHandlers();
      TweenLite.set(items, { visibility: 'visible' });
      TweenLite.from(items, 0.9, { opacity: 0, x: -100, ease: Power1.easeOut }, 0.3)
    }

    var _addEventHandlers = function () {
      toggleItems.forEach(function (element, index) {
        element.addEventListener('click', _toggleItem, false);
      });
    }

    var _toggleItem = function () {
      var parent = this.parentNode;
      var content = parent.children[1];
      if (!parent.classList.contains('is-active')) {
        isExpanded = true;
        parent.classList.add('is-active');
        TweenLite.set(content, { height: 'auto' })
        TweenLite.from(content, 0.6, { height: 0, immediateRender: false, ease: Power1.easeOut })
        pageMainEl.classList.add('results-expanded');
      } else {
        isExpanded = false;
        parent.classList.remove('is-active');
        TweenLite.to(content, 0.3, { height: 0, immediateRender: false, ease: Power1.easeOut })
        pageMainEl.classList.remove('results-expanded');
      }
      window.resizeFrame();

    }

    return {
      init: _init
    }

  }();

  Accordion.init();

}

export default Results;
